<template>
<div class="imcLogin">
    <div class="main-login">
      <p><img src="../../assets/login/loding.gif" alt=""></p>
     <p class="big-font">身份认证中</p>
     <p class="">请勿关闭此页面，稍后进行跳转</p>
    </div>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
export default {
  name: "orgpage",
  data() {
    return {
      loginName:"",
      loginPassword:"",
    };
  },
  methods: {
    onSubmit() {
      //缓存用户名密码token
      localStorage.setItem("loginName", this.loginName);
      localStorage.setItem("loginPassword", this.loginPassword);
      let param = {};
      param.method = "post";
      param.url = "/login";
      param.data = {
        loginName: this.loginName,
        passwd:  this.$md5(this.loginPassword),
      };
      Axios.ajax(param).then((res) => {
        if (res.resultCode == "0") {

          //按钮权限控制
          let menusList=[]
          for(let i=0;i<res.data.menus.length;i++){
            menusList.push(res.data.menus[i].menuCode)
          }
          Vue.prototype.menusList=menusList
          localStorage.setItem("menusList", JSON.stringify(menusList));
          localStorage.setItem("userName", res.data.userName);
          localStorage.setItem("userId", res.data.userId);
          sessionStorage.setItem("token", res.data.token);
          sessionStorage.setItem("url", res.data.roleType);
          sessionStorage.removeItem("active"); //为了让登录进去时 导航栏活跃在首页

          // if(  menusList.indexOf('HOME_PAGE')!='-1'){
          //   if (res.data.roleType == 2) {
          //     this.$router.push("/singerUer");
          //   }
          //   else if (res.data.roleType == 1 || res.data.roleType == 0) {
          //     this.$router.push("/areaUer");
          //   } else {
          //     this.$message.error("当前用户无角色!");
          //   }
          // }else{
          //   this.$router.push("/stationList");
          // }
          this.$router.push(this.tourl);


        } else {
          this.$message.error("账号密码错误!");
        }
      });
      // this.$router.push("/singerUer");
    },
  },
  mounted() {

    this.loginName=this.$route.query.loginName
    this.loginPassword=this.$route.query.loginPassword
    this.tourl=this.$route.query.tourl
    this.onSubmit()
  },
  watch:{

  },
  components: {

  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.imcLogin {
  width: 100%;
  height: 100%;
  position: relative;
}
.main-login{
  width: 200px;
  height: 200px;
  text-align: center;
  font-size: 14px;
  position: absolute;
  top: calc(50% - 100px);
  left: calc(50% - 100px);
  color: #000;
  p{
    width: 100%;
  }
  .big-font{
    font-size: 20px;
    margin: 10px 0;
  }
}
</style>

